import { isNullOrUndefined } from 'shared/lib/object/object';

export const isEmptyRelation = (relation) => {
  if (isNullOrUndefined(relation)) {
    return true;
  }
  return false;
};
